export const contractAddresses = {
  31337: "0x5FbDB2315678afecb367f032d93F642f64180aa3",
};
